// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2yYuT","title":"Info_title__WJa1v","links":"Info_links__R-6i5","link":"Info_link__2Jull","logo":"Info_logo__2GBES"};